/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bankOnlineGatewaysCreateGet } from '../fn/bank-online-gateways/bank-online-gateways-create-get';
import { BankOnlineGatewaysCreateGet$Params } from '../fn/bank-online-gateways/bank-online-gateways-create-get';
import { bankOnlineGatewaysCreatePost } from '../fn/bank-online-gateways/bank-online-gateways-create-post';
import { BankOnlineGatewaysCreatePost$Params } from '../fn/bank-online-gateways/bank-online-gateways-create-post';
import { bankOnlineGatewaysDelete } from '../fn/bank-online-gateways/bank-online-gateways-delete';
import { BankOnlineGatewaysDelete$Params } from '../fn/bank-online-gateways/bank-online-gateways-delete';
import { bankOnlineGatewaysGetBankOnlineGateways } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways';
import { BankOnlineGatewaysGetBankOnlineGateways$Params } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways';
import { bankOnlineGatewaysGetBankOnlineGatewaysAudit } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-audit';
import { BankOnlineGatewaysGetBankOnlineGatewaysAudit$Params } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-audit';
import { bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-for-increase-credit';
import { BankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Params } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-for-increase-credit';
import { bankOnlineGatewaysGetBankOnlineGatewaysWithPagination } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-with-pagination';
import { BankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Params } from '../fn/bank-online-gateways/bank-online-gateways-get-bank-online-gateways-with-pagination';
import { bankOnlineGatewaysUpdateGet } from '../fn/bank-online-gateways/bank-online-gateways-update-get';
import { BankOnlineGatewaysUpdateGet$Params } from '../fn/bank-online-gateways/bank-online-gateways-update-get';
import { bankOnlineGatewaysUpdatePut } from '../fn/bank-online-gateways/bank-online-gateways-update-put';
import { BankOnlineGatewaysUpdatePut$Params } from '../fn/bank-online-gateways/bank-online-gateways-update-put';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfBankOnlineGatewayDto } from '../models/custom-result-of-bank-online-gateway-dto';
import { CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto } from '../models/custom-result-of-list-of-get-bank-online-gateways-for-increase-credit-dto';
import { CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto } from '../models/custom-result-of-paginated-list-of-bank-online-gateway-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class BankOnlineGatewaysService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bankOnlineGatewaysGetBankOnlineGatewaysAudit()` */
  static readonly BankOnlineGatewaysGetBankOnlineGatewaysAuditPath = '/BankOnlineGateways/GetBankOnlineGatewaysAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysGetBankOnlineGatewaysAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysAudit$Response(params: BankOnlineGatewaysGetBankOnlineGatewaysAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return bankOnlineGatewaysGetBankOnlineGatewaysAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysGetBankOnlineGatewaysAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysAudit(params: BankOnlineGatewaysGetBankOnlineGatewaysAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.bankOnlineGatewaysGetBankOnlineGatewaysAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysGetBankOnlineGatewaysWithPagination()` */
  static readonly BankOnlineGatewaysGetBankOnlineGatewaysWithPaginationPath = '/BankOnlineGateways/GetBankOnlineGatewaysWithPagination';

  /**
   * For each user get BankOnlineGateways with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysGetBankOnlineGatewaysWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Response(params: BankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto>> {
    return bankOnlineGatewaysGetBankOnlineGatewaysWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get BankOnlineGateways with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysWithPagination(params: BankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto> {
    return this.bankOnlineGatewaysGetBankOnlineGatewaysWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto>): CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysCreateGet()` */
  static readonly BankOnlineGatewaysCreateGetPath = '/BankOnlineGateways/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysCreateGet$Response(params?: BankOnlineGatewaysCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return bankOnlineGatewaysCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysCreateGet(params?: BankOnlineGatewaysCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.bankOnlineGatewaysCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysCreatePost()` */
  static readonly BankOnlineGatewaysCreatePostPath = '/BankOnlineGateways/Create';

  /**
   * Create BankOnlineGateway.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysCreatePost$Response(params: BankOnlineGatewaysCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return bankOnlineGatewaysCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create BankOnlineGateway.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysCreatePost(params: BankOnlineGatewaysCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.bankOnlineGatewaysCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysUpdatePut()` */
  static readonly BankOnlineGatewaysUpdatePutPath = '/BankOnlineGateways/Update/{id}';

  /**
   * Update BankOnlineGateway.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysUpdatePut$Response(params: BankOnlineGatewaysUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return bankOnlineGatewaysUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update BankOnlineGateway.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bankOnlineGatewaysUpdatePut(params: BankOnlineGatewaysUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.bankOnlineGatewaysUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysUpdateGet()` */
  static readonly BankOnlineGatewaysUpdateGetPath = '/BankOnlineGateways/Update';

  /**
   * Get BankOnlineGateway by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysUpdateGet$Response(params?: BankOnlineGatewaysUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfBankOnlineGatewayDto>> {
    return bankOnlineGatewaysUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get BankOnlineGateway by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysUpdateGet(params?: BankOnlineGatewaysUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfBankOnlineGatewayDto> {
    return this.bankOnlineGatewaysUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfBankOnlineGatewayDto>): CustomResultOfBankOnlineGatewayDto => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysDelete()` */
  static readonly BankOnlineGatewaysDeletePath = '/BankOnlineGateways/{id}';

  /**
   * Delete BankOnlineGateway.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysDelete$Response(params: BankOnlineGatewaysDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return bankOnlineGatewaysDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete BankOnlineGateway.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysDelete(params: BankOnlineGatewaysDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.bankOnlineGatewaysDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit()` */
  static readonly BankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCreditPath = '/BankOnlineGateways/GetBankOnlineGatewaysForIncreaseCredit';

  /**
   * GetBankOnlineGatewaysForIncreaseCredit for current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Response(params?: BankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto>> {
    return bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit(this.http, this.rootUrl, params, context);
  }

  /**
   * GetBankOnlineGatewaysForIncreaseCredit for current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit(params?: BankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Params, context?: HttpContext): Observable<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto> {
    return this.bankOnlineGatewaysGetBankOnlineGatewaysForIncreaseCredit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto>): CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto => r.body)
    );
  }

  /** Path part for operation `bankOnlineGatewaysGetBankOnlineGateways()` */
  static readonly BankOnlineGatewaysGetBankOnlineGatewaysPath = '/BankOnlineGateways/GetBankOnlineGateways';

  /**
   * GetBankOnlineGateways from reseller organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bankOnlineGatewaysGetBankOnlineGateways()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysGetBankOnlineGateways$Response(params?: BankOnlineGatewaysGetBankOnlineGateways$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto>> {
    return bankOnlineGatewaysGetBankOnlineGateways(this.http, this.rootUrl, params, context);
  }

  /**
   * GetBankOnlineGateways from reseller organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bankOnlineGatewaysGetBankOnlineGateways$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bankOnlineGatewaysGetBankOnlineGateways(params?: BankOnlineGatewaysGetBankOnlineGateways$Params, context?: HttpContext): Observable<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto> {
    return this.bankOnlineGatewaysGetBankOnlineGateways$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto>): CustomResultOfListOfGetBankOnlineGatewaysForIncreaseCreditDto => r.body)
    );
  }

}
